import { useQuery } from '@tanstack/react-query'
import { fetchDashboardData } from './api'

/* weekNumber is compared against undefined rather than tested for truthiness.
   weeks.week_number is constrained to 1-22 so 0 cannot occur today, but a
   Boolean() guard would silently disable the query for ever if that changed. */
export function useCommissionerDashboard(
  poolId: string | undefined,
  weekNumber: number | undefined,
) {
  return useQuery({
    queryKey: ['commissioner', 'dashboard', poolId, weekNumber],
    queryFn: () => fetchDashboardData(poolId!, weekNumber!),
    enabled: Boolean(poolId) && weekNumber !== undefined,
    /* The page exists to answer "who still needs to pick" in the hours before
       lock, and members are picking while the commissioner watches it. A long
       cache here means chasing people who already picked, so this stays short
       and leans on react-query's refetch-on-focus. */
    staleTime: 30_000,
  })
}
